/* globals updateAffirmAsLowAs */

// main shop and cart logic
var MOBILE_BREAKPOINT = 768
var PREORDER_BUTTON_COPY = 'Place Pre-order'
var ORDER_BUTTON_COPY = 'Place Order'

// basic find for browsers that lack Array.find
var find = function(collection, predicate) {
  var i
  var element

  for (i = 0; i < collection.length; i++) {
    element = collection[i]
    if (predicate(element)) {
      return element
    }
  }
}

$(document).ready(function() {
  'use strict'
  // handle missing google analytics
  var ga = (typeof window.ga === 'function')
    ? window.ga
    : function() {}

  var currentCart
  var variantsById = {}

  var $ventSelects = $('select[data-product-type="Smart Vent"]')
  var $bridgeSelect = $('select[data-product-type="Smart Bridge"]')
  var $filterSelects = $('select[data-product-type="Smart Filter"]')
  var $allSelects = $('select[data-product-type]')
  var bridgeProductId = $bridgeSelect.attr('data-product-id')
  var bridgesNoThanks = false
  var filtersNoThanks = false
  var repeatersNoThanks = false

  var sendEnhancedEcommerce = function(item, quantity, type) {
    if (type !== 'add' && type !== 'remove') {
      return
    }

    ga('ec:addProduct', {
      'id': item.id,
      'name': item.title,
      'category': item.product_title,
      'brand': item.vendor,
      'variant': item.variant_title,
      'price': item.price / 100,
      'quantity': quantity
    })
    ga('ec:setAction', type)
    ga('send', 'event', 'UX', 'click', 'cart change')
  }

  var getTotalVentsInCart = function() {
    var numVentsInCart = 0

    $.each($ventSelects, function(index, ventItem) {
      var $ventItem = $(ventItem)

      numVentsInCart += Number($ventItem.val())
    })

    return numVentsInCart
  }

  var getTotalBridgesInCart = function() {
    var numBridges = $bridgeSelect.val()

    return Number(numBridges) || 0
  }

  var getTotalFiltersInCart = function() {
    var numFiltersInCart = 0

    $.each($filterSelects, function(index, filterItem) {
      var $filterItem = $(filterItem)

      numFiltersInCart += Number($filterItem.val())
    })

    return numFiltersInCart
  }

  var getTotalStockedFiltersInCart = function() {
    var numStockedFiltersInCart = 0

    $.each($filterSelects, function(index, filterItem) {
      var $filterItem = $(filterItem)

      // only 410 filters are stocked
      if ($filterItem.attr('data-product-sku') === 'KHSF410') {
        numStockedFiltersInCart += Number($filterItem.val())
      }
    })

    return numStockedFiltersInCart
  }

  var getTotalItemsInCart = function() {
    return currentCart && currentCart.items
      ? currentCart.items.length
      : 0
  }
  var numberWithCommas = function(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  var calculateEstimatedShippingCosts = function(weightInPounds) {
    if (weightInPounds === 0) {
      return 0
    }

    if (weightInPounds <= 0.5) {
      return 3
    }

    if (weightInPounds <= 1) {
      return 5
    }

    if (weightInPounds <= 10) {
      return 10
    }

    return 10 + Math.ceil((weightInPounds - 10) / 10) * 5
  }

  // diff two carts and send events as necessary
  var handleEnhancedEcommerce = function(previousCart, newCart) {
    if (!previousCart) {
      return
    }

    newCart.items.forEach(function(item) {
      var previousItem = find(previousCart.items, function(target) {
        return target.variant_id === item.variant_id
      })

      var previousQuantity = previousItem
        ? previousItem.quantity
        : 0

      var quantityDiff = item.quantity - previousQuantity

      if (quantityDiff) {
        var action = quantityDiff > 0
          ? 'add'
          : 'remove'

        sendEnhancedEcommerce(item, Math.abs(item.quantity), action)
      }
    })
  }

  var cacheVariants = function(item, done) {
    if (!item || item.variant_id in variantsById) {
      return done()
    }

    $.getJSON('/products/' + item.handle + '.js', function(product) {
      product.variants.forEach(function(target) {
        variantsById[target.id] = target
      })

      done()
    })
  }

  var updateFromCartJson = function(newCart, updateDisplay) {
    var cartItems = newCart.items
    var totalBeforeDiscounts = 0
    var totalAfterDiscounts = 0
    var totalDiscount = 0
    var totalItemsInCart = 0
    var totalWeight = 0
    var estimatedShippingCost = 0
    var subtotal = 0

    handleEnhancedEcommerce(currentCart, newCart)
    currentCart = newCart

    var setCartDisplay = function() {
      // convert weight to pounds
      totalWeight /= 454

      // calculate price matrix
      totalDiscount = totalBeforeDiscounts - totalAfterDiscounts
      estimatedShippingCost = calculateEstimatedShippingCosts(totalWeight)
      subtotal = totalAfterDiscounts + estimatedShippingCost
      updateAffirmAsLowAs(subtotal * 100)

      // pre-order hack
      $('#total-before-discounts').html(numberWithCommas(totalBeforeDiscounts.toFixed(2)))
      $('#total-items-in-cart').html(totalItemsInCart)
      $('#estimated-shipping').html(estimatedShippingCost.toFixed(2))
      $('#subtotal').html(subtotal.toFixed(2))

      // update the cart icon in the header
      if ($('#cart-count-toggle').hasClass('hidden-count')) {
        $('#cart-count-toggle').removeClass('hidden-count')
      }
      $('.cart-count').html(totalItemsInCart)

      var $checkoutBtn = $('input[name="checkout"]')

      $checkoutBtn.attr('value', PREORDER_BUTTON_COPY)

      if (updateDisplay) {
        $allSelects.each(function(index, item) {
          var id = item.getAttribute('data-product-id')
          var cartItem = find(cartItems, function(line) {
            return line.variant_id === id
          })

          var newQuantity = cartItem && cartItem.quantity || 0

          $(item).val(newQuantity)
        })
      }

      if (!totalItemsInCart) {
        $checkoutBtn.addClass('disabled')
      } else {
        $checkoutBtn.removeClass('disabled')

        if (totalItemsInCart === getTotalStockedFiltersInCart()) {
          $checkoutBtn.attr('value', ORDER_BUTTON_COPY)
        }
      }

      $('#discount').html(totalDiscount.toFixed(2))
    }

    var toUpdateCount = cartItems.length

    if (toUpdateCount === 0) {
      return setCartDisplay()
    }

    var updateTotals = function(item, variant) {
      if (variant) {
        var quantity = item.quantity
        var price = variant.price / 100
        var undiscountedPrice = variant.compare_at_price != null
          ? variant.compare_at_price / 100
          : variant.price / 100

        totalBeforeDiscounts += quantity * undiscountedPrice
        totalAfterDiscounts += quantity * price
        totalItemsInCart += quantity
        totalWeight += quantity * item.grams
      }

      if (--toUpdateCount <= 0) {
        setCartDisplay()
      }
    }

    cartItems.forEach(function(item) {
      if (item.variant_id in variantsById) {
        return updateTotals(item, variantsById[item.variant_id])
      }

      cacheVariants(item, function() {
        updateTotals(item, variantsById[item.variant_id])
      })
    })
  }

  var prepareAndCleanCart = function(cart) {
    var items = cart.items
    var itemsRemaining = items.length
    var updates = {}

    var finishCleaning = function() {
      if (Object.keys(updates).length === 0) {
        return updateFromCartJson(cart, true)
      }

      $.post('/cart/update.js', {updates: updates}, function(updatedCart) {
        updateFromCartJson(updatedCart, true)
      }, 'json')
    }

    if (itemsRemaining === 0) {
      return finishCleaning()
    }

    var finishItem = function(item) {
      var id = item.variant_id
      var variant = variantsById[id]

      if (!variant) {
        updates[id] = 0
      }

      if (--itemsRemaining <= 0) {
        finishCleaning()
      }
    }

    items.forEach(function(item) {
      cacheVariants(item, function() {
        finishItem(item)
      })
    })
  }

  // get the cart state
  $.get('/cart.js', function(cartJson) {
    prepareAndCleanCart(cartJson)
    $('#shop-form').show()
  }, 'json')
    .fail(function() {
      // handle failure
    })

  // init popups
  $('.vent-sizing-popup').magnificPopup({
    type: 'iframe',
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?rel=0&amp;showinfo=0&amp;autoplay=1'
        }
      }
    }
  })

  var showToastNotification = function(numVents) {
    $('.notification').fadeOut(1)

    if (numVents > 0 && getTotalBridgesInCart() < 1) {
      if (!bridgesNoThanks) {
        $('.notification.smart-bridge-educate').fadeIn(500)
      }
    } else if (getTotalBridgesInCart() < Math.ceil(getTotalVentsInCart() / 8)) {
      if (!repeatersNoThanks) {
        $('.notification.repeater-educate').fadeIn(500)
      }
    }
  }

  var updateBridgesInCart = function(numBridges) {
    var updates = {}

    $bridgeSelect.val(numBridges)
    updates[bridgeProductId] = numBridges.toString()

    $.post('/cart/update.js', {updates: updates}, function(cartJson) {
      updateFromCartJson(cartJson, false)
    }, 'json')
  }

  $('.add-bridges').click(function() {
    $('.notification').fadeOut(100)

    var addType = $(this).attr('data-add-type')
    var numBridgesNeeded = Math.ceil(getTotalVentsInCart() / 8)

    updateBridgesInCart(numBridgesNeeded)

    if (addType === 'bridges') {
      ga('send', 'event', 'Shop', 'Bridge Helper', 'accepted', numBridgesNeeded)
    } else if (addType === 'repeaters') {
      ga('send', 'event', 'Shop', 'Repeater Helper', 'accepted', numBridgesNeeded)
    }
  })

  $('.dismiss').click(function(evt) {
    var dismissType = $(evt.target).attr('data-dismiss-type')

    if (dismissType === 'bridges') {
      bridgesNoThanks = true
      ga('send', 'event', 'Shop', 'Bridge Helper', 'declined')
    } else if (dismissType === 'repeaters') {
      repeatersNoThanks = true
      ga('send', 'event', 'Shop', 'Repeater Helper', 'declined')
    } else if (dismissType === 'filters') {
      filtersNoThanks = true
      ga('send', 'event', 'Shop', 'Filter Helper', 'declined')
    }

    $('.notification').fadeOut(100)
    evt.preventDefault()
  })

  // toast for Smart Filter preorder
  var showFilterToast = function(numFilters) {
    $('.notification').fadeOut(1)
    if (numFilters > 0) {
      if (!filtersNoThanks) {
        $('.notification.smart-filter-preorder').fadeIn(500)
      }
    }
  }

  // init change handlers for products
  $('select[data-product-id]').on('change', function(evt) {
    var $target = $(evt.target)
    var productId = $target.attr('data-product-id')
    var productType = $target.attr('data-product-type')
    var numItems = evt.target.value
    var updates = {}

    updates[productId] = numItems

    $.post('/cart/update.js', {updates: updates}, function(cartJson) {
      updateFromCartJson(cartJson, false)
      if (productType === 'Smart Vent' && getTotalVentsInCart() > 0) {
        showToastNotification(getTotalVentsInCart())
      } else if (productType === 'Smart Filter' && getTotalFiltersInCart() > 0) {
        showFilterToast(getTotalFiltersInCart())
      }
    }, 'json')
  })

  // expand smart filter if necessary
  // todo: consolidate state outside of DOM
  if (window.location.search.match(/smart\-filter=1/)) {
    $('.sf-accordion')
      .addClass('active')
      .siblings('.panel')
      .addClass('show')
  }

  // prevent going to cart when trying to checkout with 0 items in cart
  $('#checkout-form').submit(function(evt) {
    if (getTotalItemsInCart() === 0) {
      evt.preventDefault()
    }
  })

  // clear cart button
  $('#clearcart').click(function() {
    $.post('/cart/clear.js', function(clearedCart) {
      updateFromCartJson(clearedCart, true)
    }, 'json')
  })

  // analytics
  $('.vent-sizing-popup').click(function() {
    ga('send', 'event', 'Education', 'Vent Sizing', 'main shop page')
  })

  $('#learn-more').click(function() {
    ga('send', 'event', 'Payment Options', 'Affirm', 'main shop page')
  })
})

// TODO: (mc) this _global_ function is called in snippets/checkout-highlights.liquid
// it really shouldn't be global nor called there
// eslint-disable-next-line
function moveScroller() {
  var $anchor = $('#scroller-anchor')
  var $scroller = $('#scroller')
  var $anchorbottom = $('#anchor-bottom')

  var ticking = false

  var move = function() {
    $scroller.css({
      position: '',
      top: '',
      right: '',
      width: ''
    })

    var st = $(window).scrollTop()
    var windowWidth = $(window).width()
    var ot = $anchor.offset().top
    var bt = $anchorbottom.offset().top
    var scrollerHeight = $scroller.height()
    var scrollerWidth = $scroller.width()
    var scrollerBottom = st + scrollerHeight

    if (windowWidth > MOBILE_BREAKPOINT && st > ot) {
      var top = (scrollerBottom < bt)
        ? '0px'
        : bt - st - scrollerHeight + 'px'

      var width = scrollerWidth + 'px'

      $scroller.css({
        position: 'fixed',
        top: top,
        right: 'initial',
        width: width,
      })
    }
  }

  var tick = function() {
    if (ticking) {
      return
    }

    ticking = true
    window.requestAnimationFrame(function() {
      move()
      ticking = false
    })
  }

  $(window).scroll(tick).resize(tick)
  tick()
}
